import { Injectable, OnDestroy, PLATFORM_ID, Inject, signal } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CookieComponent } from '../components/cookie/cookie.component';
import { GoogleService } from './google.service';

import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FacebookService } from './facebook.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
// import * as moment from 'moment';

@Injectable({
    providedIn: 'root',
})
export class CookiesService implements OnDestroy {
    private unsubscribe$ = new Subject();
    private matomosubject: BehaviorSubject<boolean>;
    private salesmanagosubject: BehaviorSubject<boolean>;
    private awinsubject: BehaviorSubject<boolean>;
    isBrowser: boolean = false;
    media = signal<string>('lg');
    smallMode = signal<boolean>(false);
    constructor(
        protected dialog: MatDialog,
        protected googleServie: GoogleService,
        @Inject(PLATFORM_ID) protected platformId: any,
        @Inject(DOCUMENT) protected document: any,
        protected route: ActivatedRoute,
        protected mediaObserver: BreakpointObserver,
        protected facebookService: FacebookService
    ) {
        this.matomosubject = new BehaviorSubject(false);
        this.salesmanagosubject = new BehaviorSubject(false);
        this.awinsubject = new BehaviorSubject(false);
        this.isBrowser = isPlatformBrowser(this.platformId);

        if (this.isBrowser) {
            setTimeout(() => {
                this.checkAwinParams();
            }, 50);
        }
        this.initMedia();
    }

    initMedia(): void {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.media.set('xs');
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.media.set('sm');
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.media.set('lg');
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.media.set('xl');
        }

        this.smallMode.set(this.media() === 'xs' || this.media() === 'sm' || this.media() === 'md');
    }

    async checkAwinParams() {
        if (this.route.snapshot.queryParams['awc']?.length > 0) {
            window.localStorage.setItem('awin_awc', this.route.snapshot.queryParams['awc']);
        }
    }

    async checkCookis(googleId, googleTagId, googleadsenseid, googleMapsId, facebookpixelid, matomoid, matomositeid, salesmanagoid, awinid, hotjarid, partnerid, hidedefaultcookie, usercentricsid, crispScriptAvailable = false) {
        if (this.document.location.pathname.startsWith('/reisen')) {
            partnerid = 'main';
        }

        if (!hidedefaultcookie) {
            let isConsented = this.getCookie(partnerid + '_COOKIE_CONSENT') === '1';

            const isConsentedAnalytics_WID = this.getCookie(partnerid + '_COOKIE_CONSENT_GANALYTICS_WID') === '1';
            const isConsentedGoogleTagMg_WID = this.getCookie(partnerid + '_COOKIE_CONSENT_GOOGLETAGMANAGER_WID') === '1';
            const isConsentedADSense_WID = this.getCookie(partnerid + '_COOKIE_CONSENT_GOOGLEADSENSE_WID') === '1';
            const isConsentedFacebookPixelMg_WID = this.getCookie(partnerid + '_COOKIE_CONSENT_FACEBOOKPIXEL_WID') === '1';
            const isConsentedGoogleMapsg_WID = this.getCookie(partnerid + '_COOKIE_CONSENT_GOOGLEMAPS_WID') === '1';
            const isConsentedYoutubeg_WID = this.getCookie(partnerid + '_COOKIE_CONSENT_YOUTUBE_WID') === '1';

            // const isConsentedMatomog_WID = this.getCookie(partnerid + '_COOKIE_CONSENT_MATOMO_WID') === '1';
            const isConsentedSalesmanagog_WID = this.getCookie(partnerid + '_COOKIE_CONSENT_SALESMANAGO_WID') === '1';
            const isConsentedAwing_WID = this.getCookie(partnerid + '_COOKIE_CONSENT_AWIN_WID') === '1';
            const isConsentedHotjarg_WID = this.getCookie(partnerid + '_COOKIE_CONSENT_HOTJAR_WID') === '1';
            const isConsentedCrispg_WID = this.getCookie(partnerid + '_COOKIE_CONSENT_CRISP_WID') === '1';
            const hasCrispConsentOption = crispScriptAvailable || isConsentedCrispg_WID;



            const isConsentedAnalytics = this.getCookie(partnerid + '_COOKIE_CONSENT_GANALYTICS') === '1';
            const isConsentedGoogleTagMg = this.getCookie(partnerid + '_COOKIE_CONSENT_GOOGLETAGMANAGER') === '1';
            const isConsentedADSense = this.getCookie(partnerid + '_COOKIE_CONSENT_GOOGLEADSENSE') === '1';
            const isConsentedFacebookPixelMg = this.getCookie(partnerid + '_COOKIE_CONSENT_FACEBOOKPIXEL') === '1';
            const isConsentedGoogleMapsg = this.getCookie(partnerid + '_COOKIE_CONSENT_GOOGLEMAPS') === '1';
            const isConsentedYOUTUBEg = this.getCookie(partnerid + '_COOKIE_CONSENT_YOUTUBE') === '1';

            // const isConsentedMATOMOg = '1'// this.getCookie(partnerid + '_COOKIE_CONSENT_MATOMO') === '1';
            const isConsentedSALESMANAGOEg = this.getCookie(partnerid + '_COOKIE_CONSENT_SALESMANAGO') === '1';
            const isConsentedAWINg = this.getCookie(partnerid + '_COOKIE_CONSENT_AWIN') === '1';
            const isConsentedHotjarg = this.getCookie(partnerid + '_COOKIE_CONSENT_HOTJAR') === '1';
            const isConsentedCrispg = this.getCookie(partnerid + '_COOKIE_CONSENT_CRISP') === '1';

            if (
                (!isConsentedAnalytics && !isConsentedAnalytics_WID && googleId?.length > 0) ||
                (!isConsentedGoogleTagMg && !isConsentedGoogleTagMg_WID && googleTagId?.length > 0) ||
                (!isConsentedADSense && !isConsentedADSense_WID && googleadsenseid?.length > 0) ||

                // (!isConsentedMATOMOg && !isConsentedMatomog_WID && matomoid?.length > 0) ||
                (!isConsentedSALESMANAGOEg && !isConsentedSalesmanagog_WID && salesmanagoid?.length > 0) ||
                (!isConsentedAWINg && !isConsentedAwing_WID && awinid?.length > 0) ||
                (!isConsentedHotjarg && !isConsentedHotjarg_WID && hotjarid?.length > 0) ||
                (!isConsentedCrispg && !isConsentedCrispg_WID && hasCrispConsentOption) ||

                (!isConsentedGoogleMapsg && !isConsentedGoogleMapsg_WID && googleMapsId?.length > 0) ||
                (!isConsentedYOUTUBEg && !isConsentedYoutubeg_WID) ||
                (!isConsentedFacebookPixelMg && !isConsentedFacebookPixelMg_WID && facebookpixelid?.length > 0)
            ) {
                isConsented = false;
            }
            if (!isConsented) {
                this.openCookies(googleId, googleTagId, googleadsenseid, googleMapsId, facebookpixelid, matomoid, matomositeid, salesmanagoid, awinid, hotjarid, true, partnerid, hasCrispConsentOption);
            } else {
                if (isConsentedAnalytics && googleId?.length > 0) {
                    this.setGAnalytics(googleId);
                }

                if (isConsentedGoogleTagMg && googleTagId?.length > 0) {
                    this.setGoogleTagManager(googleTagId);
                }

                if (isConsentedADSense && googleadsenseid?.length > 0) {
                    this.setGoogleADSense(googleTagId, false);
                }

                if (isConsentedGoogleMapsg && googleMapsId?.length > 0) {
                    this.setGoogleMap(googleMapsId, false);
                }

                if (isConsentedFacebookPixelMg && facebookpixelid?.length > 0) {
                    this.setFacebookPixelManager(facebookpixelid, false);
                }
                // new consents
                // if (isConsentedMATOMOg && matomoid?.length > 0) {
                // this.initTrackingMatomo(matomoid, matomositeid);
                // }
                this.initTrackingMatomo(matomoid, matomositeid, false);

                if (isConsentedSALESMANAGOEg && salesmanagoid?.length > 0) {
                    this.initTrackingsalesmanagoid(salesmanagoid, false);
                }

                if (isConsentedAWINg && awinid?.length > 0) {
                    this.initTrackingawinid(awinid, false);
                }

                if (isConsentedHotjarg && hotjarid?.length > 0) {
                    this.initTrackinghotjarid(hotjarid, false);
                }
            }
        } else {

            if (googleadsenseid?.length > 0) {
                this.setGoogleADSense(googleTagId, true);
            }

            if (googleMapsId?.length > 0) {
                this.setGoogleMap(googleMapsId, true);
            }

            if (facebookpixelid?.length > 0) {
                this.setFacebookPixelManager(facebookpixelid, true);
            }

            this.initTrackingMatomo(matomoid, matomositeid, true);

            if (salesmanagoid?.length > 0) {
                this.initTrackingsalesmanagoid(salesmanagoid, true);
            }

            if (awinid?.length > 0) {
                this.initTrackingawinid(awinid, true);
            }

            if (hotjarid?.length > 0) {
                this.initTrackinghotjarid(hotjarid, false);
            }
            this.setextracookis(usercentricsid);
        }
    }

    async setextracookis(usercentricsid) {
        if (usercentricsid?.length > 0) {

            const link1 = this.document.createElement('link');
            link1.setAttribute('rel', 'preconnect');
            link1.setAttribute('href', 'https://privacy-proxy.usercentrics.eu');
            this.document.documentElement.firstChild.appendChild(link1);

            const link2 = this.document.createElement('link');
            link2.setAttribute('rel', 'preload');
            link2.setAttribute('href', 'https://privacy-proxy.usercentrics.eu/latest/uc-block.bundle.js');
            link2.setAttribute('as', 'script');
            this.document.documentElement.firstChild.appendChild(link2);

            const gaScript = this.document.createElement('script');
            gaScript.setAttribute('async', '');
            gaScript.setAttribute('id', 'usercentrics-cmp');
            gaScript.setAttribute('data-settings-id', usercentricsid);
            gaScript.setAttribute('src', `https://web.cmp.usercentrics.eu/ui/loader.js`);

            this.document.documentElement.firstChild.appendChild(gaScript);

            const gaScript1 = this.document.createElement('script');
            gaScript1.innerText = `uc.reloadOnOptIn('BJz7qNsdj-7');uc.reloadOnOptIn('S1pcEj_jZX');`;
        }
    }

    async initTrackingawinid(trackingID, hidedefaultcookie) {
        const awMastertag = document.createElement('script');
        awMastertag.setAttribute('defer', 'defer');
        awMastertag.src = `https://www.dwin1.com/${trackingID}.js`;
        awMastertag.type = 'text/javascript';
        if (hidedefaultcookie) {
            awMastertag.setAttribute('type', 'text/plain');
            awMastertag.setAttribute('data-usercentrics', 'Awin');
        }
        document.getElementsByTagName('body')[0].appendChild(awMastertag);
        setTimeout(() => {
            this.awinsubject.next(true);
        }, 100);
    }

    async initTrackinghotjarid(hotjarid, hidedefaultcookie) {
        const hotjars = document.createElement('script');
        hotjars.innerText = `(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:${hotjarid},hjsv:6};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;
        if (hidedefaultcookie) {
            hotjars.setAttribute('type', 'text/plain');
            hotjars.setAttribute('data-usercentrics', 'Salesmanago');
        }
        document.documentElement.firstChild.appendChild(hotjars);
    }

    awinsubject$(): Observable<boolean> {
        return this.awinsubject.asObservable();
    }

    async initTrackingMatomo(trackingID, matomositeid, hidedefaultcookie) {
        if (trackingID?.length > 0) {
            const gaScript = document.createElement('script');
            gaScript.innerText = ` var _paq = window._paq = window._paq || [];/* tracker methods like "setCustomDimension" should be called before "trackPageView" */_paq.push(['trackPageView']);_paq.push(['enableLinkTracking']);(function() {var u='${trackingID}';_paq.push(['setTrackerUrl', u+'matomo.php']);_paq.push(['setSiteId', '${matomositeid}']);var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);})();`;
            if (hidedefaultcookie) {
                gaScript.setAttribute('type', 'text/plain');
                gaScript.setAttribute('data-usercentrics', 'Matomo');
            }
            document.documentElement.firstChild.appendChild(gaScript);
            setTimeout(() => {
                this.matomosubject.next(true);
            }, 100);
        }
    }

    matomosubject$(): Observable<boolean> {
        return this.matomosubject.asObservable();
    }

    async initTrackingsalesmanagoid(trackingID, hidedefaultcookie) {
        const gaScript = document.createElement('script');
        gaScript.innerText = `var _smid = '${trackingID}';var _smapp = 1;var _smcustom = true;(function(w, r, a, sm, s ) {w['SalesmanagoObject'] = r;w[r] = w[r] || function () {( w[r].q = w[r].q || [] ).push(arguments)};sm = document.createElement('script');sm.type = 'text/javascript'; sm.async = true; sm.src = a;s = document.getElementsByTagName('script')[0];s.parentNode.insertBefore(sm, s);})(window, 'sm', ('https:' == document.location.protocol ? 'https://' : 'http://')+ 'www.salesmanago.com/static/sm.js');`;
        if (hidedefaultcookie) {
            gaScript.setAttribute('type', 'text/plain');
            gaScript.setAttribute('data-usercentrics', 'Salesmanago');
        }
        document.body.appendChild(gaScript);

        setTimeout(() => {
            this.salesmanagosubject.next(true);
        }, 100);
    }

    salesmanagosubject$(): Observable<boolean> {
        return this.salesmanagosubject.asObservable();
    }

    postmessageconsent(partnerid): any {
        return {
            consents: [
                {
                    name: 'analytics',
                    consent: this.getCookie(partnerid + '_COOKIE_CONSENT_GANALYTICS') === '1'
                },
                {
                    name: 'essential',
                    consent: true
                },
                {
                    name: 'youtube',
                    consent: this.getCookie(partnerid + '_COOKIE_CONSENT_YOUTUBE') === '1'
                },
                {
                    name: 'googl-tag-manager',
                    consent: this.getCookie(partnerid + '_COOKIE_CONSENT_GOOGLETAGMANAGER') === '1'
                },
            ]
        }
    }

   
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    openCookies(googleId, googleTagId, googleadsenseid, googleMapsId, facebookpixelid, matomoid, matomositeid, salesmanagoid, awinid, hotjarid, auto, partnerid, crispScriptAvailable = false) {
        if (this.isBrowser) {
            const isConsentedAnalytics = this.getCookie(partnerid + '_COOKIE_CONSENT_GANALYTICS') === '1';
            const isConsentedGoogleTagMg = this.getCookie(partnerid + '_COOKIE_CONSENT_GOOGLETAGMANAGER') === '1';
            const isConsentedGoogleAdsense = this.getCookie(partnerid + '_COOKIE_CONSENT_GOOGLEADSENSE') === '1';
            const isConsentedGoogleMaps = this.getCookie(partnerid + '_COOKIE_CONSENT_GOOGLEMAPS') === '1';
            const isConsentedYouTube = this.getCookie(partnerid + '_COOKIE_CONSENT_YOUTUBE') === '1';
            const isConsentedFacebookPixelMg = this.getCookie(partnerid + '_COOKIE_CONSENT_FACEBOOKPIXEL') === '1';

            const isConsentedMATOMOg = ''; // this.getCookie(partnerid + '_COOKIE_CONSENT_MATOMO') === '1';
            const isConsentedSALESMANAGOEg = this.getCookie(partnerid + '_COOKIE_CONSENT_SALESMANAGO') === '1';
            const isConsentedAWINg = this.getCookie(partnerid + '_COOKIE_CONSENT_AWIN') === '1';
            const isConsentedHotjarg = this.getCookie(partnerid + '_COOKIE_CONSENT_HOTJAR') === '1';
            const isConsentedCrispg = this.getCookie(partnerid + '_COOKIE_CONSENT_CRISP') === '1';
            const hasCrispConsentOption = crispScriptAvailable || this.getCookie(partnerid + '_COOKIE_CONSENT_CRISP_WID') === '1';

            const config = new MatDialogConfig();
            config.panelClass = 'cookiePanel';
            config.maxWidth = '600px';
            config.maxHeight = '100%';
            if (this.smallMode()) {
                config.height = '100%';
            }
            config.autoFocus = false;
            if (auto) {
                config.hasBackdrop = false;
                config.position = { bottom: '.5rem' };
            }
            config.data = {
                components: [
                    {
                        name: 'Google Analytics',
                        checked: isConsentedAnalytics,
                        id: googleId,
                        description: 'Wir verwenden Google Analytics, um die Website-Nutzung zu analysieren. Die daraus gewonnenen Daten werden genutzt, um unsere Website sowie Werbemaßnahmen zu optimieren.',
                        privacy: 'https://policies.google.com/privacy'
                    },
                    {
                        name: 'Google Tag Manager',
                        checked: isConsentedGoogleTagMg,
                        id: googleTagId,
                        description: 'Google Tag-Management-System. Damit kann der Benutzer Messcodes und zugehörige Codefragmente aktualisieren, die auf der Website des Benutzers oder in der mobilen App als Tags bezeichnet werden.',
                        privacy: 'https://policies.google.com/privacy'
                    },
                    {
                        name: 'Google ADSense',
                        checked: isConsentedGoogleAdsense,
                        id: googleadsenseid,
                        description: 'Google AdSense ist ein Online-Dienst des US-amerikanischen Unternehmens Google LLC, der Werbung auf Websites außerhalb der hauseigenen Angebote darstellt. Kern des Werbedienstes ist ein Algorithmus, der bei der Auswahl der Werbung die Inhalte der Zielwebseite berücksichtigt.',
                        privacy: 'https://policies.google.com/privacy'
                    },
                    {
                        name: 'Google Maps',
                        checked: isConsentedGoogleMaps,
                        id: googleMapsId,
                        description: 'Google Maps ist ein Web-Mapping-Dienst. Die gesammelten Daten werden für das anzeigen von Karten verwendet.',
                        privacy: 'https://policies.google.com/privacy'
                    },
                    {
                        name: 'YouTube',
                        checked: isConsentedYouTube,
                        id: 'YouTube',
                        description: 'Wird verwendet, um integrierte Inhalte der Videoplattform YouTube auf unserer Website freizuschalten. Die durch die Cookies erzeugten Informationen über Benutzung des Onlineangebotes durch die Nutzer werden.',
                        privacy: 'https://policies.google.com/privacy'
                    },
                    {
                        name: 'Facebook Pixel',
                        checked: isConsentedFacebookPixelMg,
                        id: facebookpixelid,
                        description: 'Das ist ein Werbung-messen-System.'
                    },
                    {
                        name: 'Matomo',
                        checked: isConsentedMATOMOg,
                        withoutcheckbox: true,
                        id: matomoid,
                        description: 'Diese Webseite verwendet Matomo, um anonyme Nutzungsstatistiken zu erfassen und unsere Webseite zu verbessern. Wir benötigen Ihre Einwilligung zur Verwendung von Matomo. Sie können jederzeit Ihre Einwilligung widerrufen. Weitere Informationen finden Sie in unserer Datenschutzerklärung.',
                        privacy: 'https://de.matomo.org/privacy-policy/'
                    },
                    {
                        name: 'Salesmanago',
                        checked: isConsentedSALESMANAGOEg,
                        id: salesmanagoid,
                        description: 'Diese Webseite verwendet Sales Manago, um personalisierte Inhalte und Angebote zu erstellen und das Nutzerverhalten zu analysieren. Wir benötigen Ihre Einwilligung zur Verwendung von Sales Manago. Sie können jederzeit Ihre Einwilligung widerrufen. Weitere Informationen finden Sie in unserer Datenschutzerklärung.',
                        privacy: 'https://www.salesmanago.com/info/information-obligation.htm'
                    },
                    {
                        name: 'AWIN',
                        checked: isConsentedAWINg,
                        id: awinid,
                        description: 'Diese Webseite verwendet AWIN, um Affiliate-Marketing zu betreiben und die Leistung unserer Affiliate-Partner zu messen. Wir benötigen Ihre Einwilligung zur Verwendung von AWIN. Sie können jederzeit Ihre Einwilligung widerrufen. Weitere Informationen finden Sie in unserer Datenschutzerklärung.',
                        privacy: 'https://www.awin.com/de/datenschutzerklarung'
                    },
                    {
                        name: 'hotjar',
                        checked: isConsentedHotjarg,
                        id: hotjarid,
                        description: 'Diese Webseite verwendet hotjar, um Affiliate-Marketing zu betreiben und die Leistung unserer Affiliate-Partner zu messen. Wir benötigen Ihre Einwilligung zur Verwendung von hotjar. Sie können jederzeit Ihre Einwilligung widerrufen. Weitere Informationen finden Sie in unserer Datenschutzerklärung.',
                        privacy: 'https://www.hotjar.com/de/datenschutz/'
                    },
                    {
                        name: 'Crisp Chat',
                        checked: isConsentedCrispg,
                        id: hasCrispConsentOption ? 'Crisp Chat' : '',
                        description: 'Diese Webseite verwendet Crisp Chat, um eine direkte Chat-Kommunikation mit Besuchern zu ermöglichen. Wir benötigen Ihre Einwilligung zur Verwendung von Crisp Chat.',
                        privacy: 'https://crisp.chat/en/privacy/'
                    }
                ]
            };

            const dialogRef = this.dialog.open(CookieComponent, config);
            dialogRef.afterClosed().pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe((result: any[]) => {
                if (result) {
                    this.resetCookies();
                    for (let i = 0; i < result?.length; i++) {
                        if (result[i].name === 'Google Analytics') {
                            const val = result[i].checked ? '1' : '0';
                            if (val === '1') {
                                this.setGAnalytics(result[i].id);
                            }
                            this.setCookie(partnerid + '_COOKIE_CONSENT_GANALYTICS', val, 730, partnerid);
                            this.setCookie(partnerid + '_COOKIE_CONSENT_GANALYTICS_WID', (result[i].id?.length > 0 ? '1' : '0'), 730, partnerid);
                        }
                        if (result[i].name === 'Google Tag Manager') {
                            const val = result[i].checked ? '1' : '0';
                            if (val === '1') {
                                this.setGoogleTagManager(result[i].id);
                            }
                            this.setCookie(partnerid + '_COOKIE_CONSENT_GOOGLETAGMANAGER', val, 730, partnerid);
                            this.setCookie(partnerid + '_COOKIE_CONSENT_GOOGLETAGMANAGER_WID', (result[i].id?.length > 0 ? '1' : '0'), 730, partnerid);
                        }
                        if (result[i].name === 'Google ADSense') {
                            const val = result[i].checked ? '1' : '0';
                            if (val === '1') {
                                this.setGoogleADSense(result[i].id, false);
                            }
                            this.setCookie(partnerid + '_COOKIE_CONSENT_GOOGLEADSENSE', val, 730, partnerid);
                            this.setCookie(partnerid + '_COOKIE_CONSENT_GOOGLEADSENSE_WID', (result[i].id?.length > 0 ? '1' : '0'), 730, partnerid);
                        }
                        if (result[i].name === 'Google Maps') {
                            const val = result[i].checked ? '1' : '0';
                            if (val === '1') {
                                this.setGoogleMap(result[i].id, false);
                            }
                            this.setCookie(partnerid + '_COOKIE_CONSENT_GOOGLEMAPS', val, 730, partnerid);
                            this.setCookie(partnerid + '_COOKIE_CONSENT_GOOGLEMAPS_WID', (result[i].id?.length > 0 ? '1' : '0'), 730, partnerid);
                        }
                        if (result[i].name === 'YouTube') {
                            const val = result[i].checked ? '1' : '0';
                            this.setCookie(partnerid + '_COOKIE_CONSENT_YOUTUBE', val, 730, partnerid);
                            this.setCookie(partnerid + '_COOKIE_CONSENT_YOUTUBE_WID', (result[i].id?.length > 0 ? '1' : '0'), 730, partnerid);
                        }
                        if (result[i].name === 'Facebook Pixel') {
                            const val = result[i].checked ? '1' : '0';
                            if (val === '1') {
                                this.setFacebookPixelManager(result[i].id, false);
                            }
                            this.setCookie(partnerid + '_COOKIE_CONSENT_FACEBOOKPIXEL', val, 730, partnerid);
                            this.setCookie(partnerid + '_COOKIE_CONSENT_FACEBOOKPIXEL_WID', (result[i].id?.length > 0 ? '1' : '0'), 730, partnerid);
                        }

                        if (result[i].name === 'Matomo') {
                            const val = result[i].checked ? '1' : '0';
                            // if (val === '1') {
                            //     this.initTrackingMatomo(result[i].id, matomositeid);
                            // }
                            this.initTrackingMatomo(result[i].id, matomositeid, false);
                            // this.setCookie(partnerid + '_COOKIE_CONSENT_MATOMO', val, 730, partnerid);
                            // this.setCookie(partnerid + '_COOKIE_CONSENT_MATOMO_WID', (result[i].id?.length > 0 ? '1' : '0'), 730, partnerid);
                        }
                        if (result[i].name === 'Salesmanago') {
                            const val = result[i].checked ? '1' : '0';
                            if (val === '1') {
                                this.initTrackingsalesmanagoid(result[i].id, false);
                            }
                            this.setCookie(partnerid + '_COOKIE_CONSENT_SALESMANAGO', val, 730, partnerid);
                            this.setCookie(partnerid + '_COOKIE_CONSENT_SALESMANAGO_WID', (result[i].id?.length > 0 ? '1' : '0'), 730, partnerid);
                        }
                        if (result[i].name === 'AWIN') {
                            const val = result[i].checked ? '1' : '0';
                            if (val === '1') {
                                this.initTrackingawinid(result[i].id, false);
                            }
                            this.setCookie(partnerid + '_COOKIE_CONSENT_AWIN', val, 730, partnerid);
                            this.setCookie(partnerid + '_COOKIE_CONSENT_AWIN_WID', (result[i].id?.length > 0 ? '1' : '0'), 730, partnerid);
                        }
                        if (result[i].name === 'hotjar') {
                            const val = result[i].checked ? '1' : '0';
                            if (val === '1') {
                                this.initTrackinghotjarid(result[i].id, false);
                            }
                            this.setCookie(partnerid + '_COOKIE_CONSENT_HOTJAR', val, 730, partnerid);
                            this.setCookie(partnerid + '_COOKIE_CONSENT_HOTJAR_WID', (result[i].id?.length > 0 ? '1' : '0'), 730, partnerid);
                        }
                        if (result[i].name === 'Crisp Chat') {
                            const val = result[i].checked ? '1' : '0';
                            this.setCookie(partnerid + '_COOKIE_CONSENT_CRISP', val, 730, partnerid);
                            this.setCookie(partnerid + '_COOKIE_CONSENT_CRISP_WID', (result[i].id?.length > 0 ? '1' : '0'), 730, partnerid);
                            if (val !== '1') {
                                this.removeCrispChat();
                            }
                        }
                    }

                    this.setCookie(partnerid + '_COOKIE_CONSENT', '1', 730, partnerid);
                    // this.setCookie(partnerid + '_COOKIE_CONSENT_RES', moment().format('YYYY-MM-DD'), 730, partnerid);
                    window.location.reload();
                }
            });
        }
    }

    setGAnalytics(id) {
        if (id?.length > 0) {
            this.googleServie.loadGoogleAnalytics();
        }
    }

    setGoogleTagManager(id) {
        if (id?.length > 0) {
            this.googleServie.updateGoogleTagsdef();
        }
    }

    setGoogleADSense(id, hidedefaultcookie) {
        if (id?.length > 0) {
            this.googleServie.loadGoogleAdsense(id, hidedefaultcookie);
        }
    }

    setGoogleMap(id, hidedefaultcookie) {
        if (id?.length > 0) {
            this.googleServie.loadGoogleMap(id, hidedefaultcookie);
        }
    }

    setFacebookPixelManager(id, hidedefaultcookie) {
        if (id?.length > 0) {
            this.facebookService.loadFacebookPixelManager(id, hidedefaultcookie);
        }
    }

    hasCrispExtraScript(extraScripts: string): boolean {
        return /(\$crisp|CRISP_WEBSITE_ID|client\.crisp\.chat)/i.test(extraScripts || '');
    }

    hasCrispConsent(partnerid: string): boolean {
        return this.getCookie(partnerid + '_COOKIE_CONSENT_CRISP') === '1';
    }

    removeCrispChat(): void {
        if (!this.isBrowser) {
            return;
        }
        const crispElements = this.document.querySelectorAll(
            'script[src*="client.crisp.chat"], script[data-clever-extra-script="true"], #crisp-chatbox'
        );
        crispElements.forEach((element: HTMLElement) => {
            const src = element.getAttribute('src') || '';
            const text = element.textContent || '';
            if (element.id === 'crisp-chatbox' || this.hasCrispExtraScript(src) || this.hasCrispExtraScript(text)) {
                element.remove();
            }
        });
        delete (window as any).$crisp;
        delete (window as any).CRISP_WEBSITE_ID;
    }

    resetCookies(): void {
        const allCookies = document.cookie.split(';');

        // The "expire" attribute of every cookie is
        // Set to "Thu, 01 Jan 1970 00:00:00 GMT"
        for (let i = 0; i < allCookies.length; i++) {
            document.cookie = allCookies[i] + '=;expires=' +
                new Date(0).toUTCString();
        }
    }

    getCookie(name: string) {
        const ca: Array<string> = document.cookie.split(';');
        const caLen: number = ca.length;
        const cookieName = `${name}=`;
        let c: string;

        for (let i: number = 0; i < caLen; i += 1) {
            c = ca[i].replace(/^\s+/g, '');
            if (c.indexOf(cookieName) === 0) {
                return c.substring(cookieName.length, c.length);
            }
        }
        return '';
    }

    setCookie(name: string, value: string, expireDays: number, path: string = '') {
        const d: Date = new Date();
        d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
        const expires: string = `expires=${d.toUTCString()}`;
        const cpath: string = path ? '; path=/' : '';
        // const cpath1: string = `; path=/${path}`;
        // document.cookie = `${name}=${value}; expires=Thu, 01 Jan 1970 00:00:00 GMT${cpath1}`;
        this.document.cookie = `${name}=${value}; ${expires}${cpath}`;
    }
}
